// Owner: P1 piece 5 "Touch ledger and Today" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): keep the one export `feature` and its type; fill
// `app`/`bare` and `nav`. Paths: `/today`.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Sunrise } from 'lucide-react'
import type { Feature } from '../feature.ts'

export const feature: Feature = {
  app: (parent) => [createRoute({ getParentRoute: () => parent, path: '/today', component: lazyRouteComponent(() => import('./TodayScreen.tsx')) })],
  nav: [{ to: '/today', label: 'nav.today', icon: Sunrise, group: 'work', key: 't' }],
}
